<div class="kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--fixed kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-page--loading">

  <!-- begin:: Header Mobile -->
  <div id="kt_header_mobile" class="kt-header-mobile  kt-header-mobile--fixed ">
    <div class="kt-header-mobile__logo">
      <a href="index.html">
        <img alt="Logo" src="assets/media/logos/logo-light.png" />
      </a>
    </div>
    <div class="kt-header-mobile__toolbar">
      <button class="kt-header-mobile__toggler kt-header-mobile__toggler--left"
              id="kt_aside_mobile_toggler">
        <span></span>
      </button>
      <button class="kt-header-mobile__toggler d-none" id="kt_header_mobile_toggler"><span></span></button>
      <button class="kt-header-mobile__topbar-toggler" id="kt_header_mobile_topbar_toggler">
        <i class="flaticon-more"></i>
      </button>
    </div>
  </div>
  <div class="kt-grid kt-grid--hor kt-grid--root">
    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">

      <div class="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop"
           id="kt_aside">

        <!-- begin:: Aside -->
        <div class="kt-aside__brand kt-grid__item " id="kt_aside_brand">
          <div class="kt-aside__brand-logo">
            <a>
              <img alt="Logo" src="assets/media/logos/logo-light.png" />
              <span *ngIf="!systemName">ESKA<sup>®</sup> Carenet </span>
              <span *ngIf="systemName" class="system-name">{{portalName}}</span>
            </a>
          </div>
          <div class="kt-aside__brand-tools">
            <button class="kt-aside__brand-aside-toggler" id="kt_aside_toggler">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                          fill="#000000" fill-rule="nonzero"
                          transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) " />
                    <path d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                          fill="#000000" fill-rule="nonzero" opacity="0.3"
                          transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) " />
                  </g>
                </svg>
              </span>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                          fill="#000000" fill-rule="nonzero" />
                    <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                          fill="#000000" fill-rule="nonzero" opacity="0.3"
                          transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
                  </g>
                </svg>
              </span>
            </button>

            <!--
      <button class="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left" id="kt_aside_toggler"><span></span></button>
      -->
          </div>
        </div>
        <!-- end:: Aside -->
        <!-- begin:: Aside Menu -->


        <div class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
          <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1"
               data-ktmenu-dropdown-timeout="500">
            <ul class="kt-menu__nav">

              <li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover" *ngIf="userMenus?.length > 1000">

                <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                  <span class="kt-menu__link-icon">
                    <i class="fa fa-search"></i>
                  </span><span class="kt-menu__link-text">Search</span><i class="kt-menu__ver-arrow la la-angle-right"></i>
                </a>

                <div class="menu_sub_sub kt-menu__submenu">
                  <span class="kt-menu__arrow"></span>
                  <ul class="kt-menu__subnav">
                    <li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                      <div class="col-md-11">
                        <p-autoComplete dropdownIcon="pi pi-search" [showEmptyMessage]="false"
                                        [suggestions]="lastLevelMenusSugg" styleClass='form-control form-control-sm'
                                        (completeMethod)="onMenuSearch($event)" field="name" [dropdown]="true"
                                        (onSelect)="onMenuSelect($event)">
                          <ng-template pTemplate="header">
                            <div class="row">
                              <div class="input-group col-md-12">
                                <div class="form-group form-group-sm col-md-12">name</div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template let-menu pTemplate="item">
                            <div class="row">
                              <div class="input-group col-md-12">
                                <div class="form-group form-group-sm col-md-12">
                                  <div>{{menu.name}}</div>
                                  <div>{{menu.name2}}</div>
                                </div>
                              </div>
                            </div>
                          </ng-template>

                        </p-autoComplete>
                      </div>
                    </li>
                  </ul>
                </div>


              </li>

              <li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover" *ngFor="let oFirstLvl of userMenus">

                <a href="javascript:;" [id]="oFirstLvl.id"
                   class="kt-menu__link kt-menu__toggle">
                  <span class="kt-menu__link-icon">
                    <i [class]="oFirstLvl.icon?oFirstLvl.icon:''">  </i>
                  </span><span class="kt-menu__link-text">{{oFirstLvl.label }}</span><i class="kt-menu__ver-arrow la la-angle-right"></i>
                </a>

                <div class="menu_sub_sub kt-menu__submenu">
                  <span class="kt-menu__arrow"></span>
                  <ul class="kt-menu__subnav">

                    <li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true"
                        data-ktmenu-submenu-toggle="hover" *ngFor="let SecondLvl of oFirstLvl.items">
                      <a *ngIf="!SecondLvl.routerLink" href="javascript:;" [id]="SecondLvl.id"
                         class="kt-menu__link kt-menu__toggle">
                        <span class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                          <span></span>
                        </span><span class="kt-menu__link-text">{{SecondLvl.label}}</span><i class="kt-menu__ver-arrow la la-angle-right"></i>
                      </a>

                      <a *ngIf="SecondLvl.routerLink" (click)="SecondLvl.command(SecondLvl);setPageTitle(SecondLvl.label)" [id]="SecondLvl.id"
                         class="kt-menu__link kt-menu__toggle">
                        <span class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                          <span></span>
                        </span><span class="kt-menu__link-text">{{SecondLvl.label}}</span><i class="kt-menu__link-text"></i>
                      </a>

         
                    </li>
                  </ul>
                </div>

              </li>

               

            </ul>
          </div>
        </div>
        <!-- end:: Aside Menu -->

      </div>

      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
        <!-- begin:: Header -->
        <div id="kt_header" class="kt-header kt-grid__item  kt-header--fixed ">

          <!-- begin:: Header Menu -->
 
          <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
            <div id="kt_header_menu"
                 class="kt-header-menu kt-header-menu-mobile  kt-header-menu--layout-default ">
              <ul class="kt-menu__nav ">
 
                <li class="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel" data-ktmenu-submenu-toggle="click"
                    aria-haspopup="true" *ngIf="selectedSystem">
                  <p-menubar [model]="selectedSystem"></p-menubar>
                </li>
                <li class="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel" data-ktmenu-submenu-toggle="click"
                    aria-haspopup="true">
                  <p-menubar [model]="subModules"></p-menubar>
                </li>
                <li class="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel" data-ktmenu-submenu-toggle="click"
                    aria-haspopup="true">
                  <p-menubar [model]="pages"></p-menubar>
                </li>

              </ul>
            </div>
          </div>

          <!--<button class="btn btn-sm btn-brand"> Back To Website</button>-->
          <!-- end:: Header Menu -->
          <!-- begin:: Header Topbar -->
          <div class="kt-header__topbar">
           
            <div (click)="webSitePage()" class="kt-header__topbar-item" *ngIf="this.showWebSite">
              <div class="kt-header__topbar-wrapper" data-offset="30px,0px"
                   aria-expanded="true">
                <span class="kt-header__topbar-icon kt-pulse--brand">
                  <i title="Website" class="fa fa-globe"></i>
                </span>
              </div>
            </div>
            <!--end: Website -->
            <!--begin: My Cloud Account -->
            <div (click)="AccountSetupProgress()" class="kt-header__topbar-item" *ngIf="isCloudManagerEnabled && false">
              <div class="kt-header__topbar-wrapper" data-offset="30px,0px"
                   aria-expanded="true" pTooltip="My Cloud Account" tooltipPosition="bottom">
                <span class="kt-header__topbar-icon kt-pulse--brand">
                  <i class="fa fa-cloud" style="padding-top:2px">
                  </i>
                  <span class="kt-pulse__ring"></span>
                </span>

              </div>
            </div>
            <!--begin: Videos -->

            <div class="kt-header__topbar-item dropdown" *ngIf="isCloudManagerEnabled">
              <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="30px,0px" aria-expanded="true">
                <span class="kt-header__topbar-icon kt-pulse kt-pulse--brand">
                  <i title="How to use Carenet ?" class="fa fa-play-circle" style="padding-top:2px">
                  </i>
                  <span class="kt-pulse__ring"></span>
                </span>

                <!--
              Use dot badge instead of animated pulse effect:
              <span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand"></span>
          -->
              </div>
              <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
                <form>

                  <!--begin: Head -->
                  <div class="kt-head kt-head--skin-dark kt-head--fit-x kt-head--fit-b" style="background: linear-gradient(45deg, #00b8ff, #4284a1);">
                    <h3 class="kt-head__title">
                      How to use Carenet ?
                      <br />
                      &nbsp;
                    </h3>
                  </div>
                  <!--end: Head -->
                  <div class="tab-content">
                    <div class="tab-pane active show" id="topbar_notifications_notifications" role="tabpanel">
                      <div class="kt-notification kt-margin-t-10 kt-margin-b-10 kt-scroll ps" data-scroll="true" data-height="300" data-mobile-height="200" style="height: 300px; overflow: hidden;">
                        <a (click)="EmbedVideoDialog(vid.URL)" class="kt-notification__item" *ngFor="let vid of listOfVideo">
                          <div class="kt-notification__item-icon">
                            <i class="{{vid.Icon}}"></i>
                          </div>
                          <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title">
                              {{vid.Name}}
                            </div>
                            <div class="kt-notification__item-time">
                            </div>
                          </div>
                        </a>

                        <div class="ps__rail-x" style="left: 0px; bottom: 0px;"><div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div></div><div class="ps__rail-y" style="top: 0px; right: 0px;"><div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div></div>
                      </div>
                    </div>

                  </div>
                </form>
              </div>
            </div>
            <!--end: Videos -->
            <!--end: My Cloud Account -->
            <!--begin: Carenet Landing -->
      

            <!--end: Carenet Landing -->
            <!--begin: Home -->
            <div (click)="homePage()" class="kt-header__topbar-item" *ngIf="false">
              <div class="kt-header__topbar-wrapper" data-offset="30px,0px"
                   aria-expanded="true" pTooltip="Home" tooltipPosition="bottom">
                <span class="kt-header__topbar-icon kt-pulse--brand">
                  <i class="fa fa-home">
                  </i>
                  <span class="kt-pulse__ring"></span>
                </span>
                <!--
              Use dot badge instead of animated pulse effect:
              <span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand"></span>
          -->
              </div>
            </div>

            <!--end: Home -->
 
            <!--begin: Language -->
            <div class="kt-header__topbar-item kt-header__topbar-item--langs">
              <div _ngcontent-ipc-c4="" class="kt-header__topbar-wrapper" data-offset="10px,0px" data-toggle="dropdown">
                <span _ngcontent-ipc-c4="" class="kt-header__topbar-icon"><img _ngcontent-ipc-c4="" alt="" class="" [src]="selectedLangImageUrl"></span>
              </div>
              <div _ngcontent-ipc-c4="" class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
                <ul _ngcontent-ipc-c4="" class="kt-nav kt-margin-t-10 kt-margin-b-10">
                  <li [ngClass]="enLangClass">
                    <a class="kt-nav__link" (click)="switchLanguage('en')">
                      <span class="kt-nav__link-icon">
                        <img alt="" src="assets/media/flags/260-united-kingdom.svg">
                      </span>
                      <span class="kt-nav__link-text">{{'MasterPageComponent.Labels.English' | translate }}</span>
                    </a>
                  </li>
                  <li [ngClass]="arLangClass">
                    <a class="kt-nav__link" (click)="switchLanguage('ar')">
                      <span class="kt-nav__link-icon">
                        <img alt="" src="assets/media/flags/077-jordan.svg">
                      </span>
                      <span class="kt-nav__link-text">{{'MasterPageComponent.Labels.Arabic' | translate }}</span>
                    </a>
                  </li>
                  <li _ngcontent-ipc-c4="" class="kt-nav__item">
                    <a _ngcontent-ipc-c4="" class="kt-nav__link" href="#">
                      <span _ngcontent-ipc-c4="" class="kt-nav__link-icon">
                        <img _ngcontent-ipc-c4="" alt="" src="assets/media/flags/184-sweden.svg">
                      </span><span _ngcontent-ipc-c4="" class="kt-nav__link-text">{{'MasterPageComponent.Labels.Swedish' | translate }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!--end: Language -->
 
            <!--begin: User Bar -->
            <div class="kt-header__topbar-item kt-header__topbar-item--user">
              <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
                <div class="kt-header__topbar-user">
                  <span class="kt-header__topbar-welcome kt-hidden-mobile"> {{'MasterPageComponent.Labels.Hi' | translate }}</span>
                  <span class="kt-header__topbar-username kt-hidden-mobile">{{name}}</span>
                  <span class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">{{user.Username[0] | titlecase}}</span>
                </div>
              </div>
              <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">

                <!--begin: Head -->
                <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                     style="background: linear-gradient(45deg, #00b8ff, #4284a1);">
                  <div class="kt-user-card__avatar">
                    <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
                    <span class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold"
                          style="background-color: rgba(255, 255, 255, 0.3); color: #f2fbfd !important;">{{user.Username[0] | titlecase}} </span>
                  </div>
                  <div class="kt-user-card__name">
                    {{name}}
                  </div>
                  <!--<div class="kt-user-card__badge">
              <span class="btn btn-success btn-sm btn-bold btn-font-md">23 messages</span>
            </div>-->
                </div>
                <!--end: Head -->
                <!--begin: Navigation -->
                <div class="kt-notification">
                  <div class="kt-notification__custom kt-space-between">

                    <button class="btn btn-label btn-label-brand btn-sm btn-bold" (click)="logoutUser()">
                      <i class="fa fa-sign-out-alt"></i> {{'MasterPageComponent.Labels.SignOut' | translate }}
                    </button>

                    <button class="btn btn-label btn-label-brand btn-sm btn-bold" (click)="ShowChangePassword()" *ngIf="this.changePasswordEnabled == undefined || this.changePasswordEnabled == true">
                      <i class="fa fa-unlock-alt"></i> {{'MasterPageComponent.Labels.ChangePassword' | translate }}
                    </button>

                  </div>
                </div>
                <!--end: Navigation -->
              </div>
            </div>

   
            <!--end: User Bar -->
            <div class="kt-header__topbar-item header_logo">
              <div class="logo_img_header">
                <img class="w-auto" [src]="imageLogo" *ngIf="imageLogo != null">
                <img class="w-auto" src="./assets/media/logos/eska-Logo.png" *ngIf="imageLogo == null">
              </div>
            </div>
          </div>

          <!-- end:: Header Topbar -->
        </div>




        <!-- end:: Header -->
        <div class="kt-content"
             id="kt_content">
          <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">


            <router-outlet></router-outlet>


            <!-- end:: Content -->
          </div>
        </div>

        <!-- begin:: Footer -->
        <div class="kt-footer  kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"
             id="kt_footer">
          <div class="kt-container  kt-container--fluid ">
            <div class="kt-footer__copyright">
              <div>
                © {{currentYear}}
                <span class="text-primary" *ngIf="!footerSystemName"> ESKADENIA Software </span>
                <span class="text-primary" *ngIf="footerSystemName"> {{footerSystemName}} </span>
                {{'MasterPageComponent.Labels.AllRightReserved' | translate }}
              </div>
            </div>
            <div class="kt-footer__menu eska_logo">
              <div class="kt-footer__copyright">Build No. {{buildNo}}</div>
              <span class="img tooltip-cont">
                <span class="tooltiptext">
                  Powered by ESKADENIA<sup>®</sup> Software, a product &amp;
                  market-oriented organization that assists enterprises &amp;
                  promotes businesses by use of highly effective products, IT
                  solutions &amp; tools.
                </span>
                <img src="assets/media/logos/logo-dark.png" alt="{{'MasterPageComponent.Labels.ESKADENIASoftware' | translate }}" />
              </span>
            </div>
          </div>
        </div>

        <!-- end:: Footer -->
      </div>
    </div>
    </div>
</div>

<p-dialog class="prime-form-control" [appendTo]="'body'" header="{{'MasterPageComponent.Labels.ChangePassword' | translate }}"
          [style]="{width: '50%',left:'15px'}" [responsive]="true" [(visible)]="showChangePassword" [modal]="true" [draggable]="false">
  <div class="col-12">
    <div class="row">
      <div class="form-group form-group-sm col-md-12">
        <label>{{'MasterPageComponent.Labels.Username' | translate }}</label>
        <input type="text" [(ngModel)]="UserName" disabled class="form-control" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>{{'MasterPageComponent.Labels.OldPassword' | translate }}</label>
        <!--<p-password [(ngModel)]="oldPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="oldPassword" class="form-control required" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>
          {{'MasterPageComponent.Labels.NewPassword' | translate }}
          <span *ngIf="checkMatchPassword" class="password-warrning">*</span>
        </label>
        <!--<p-password [(ngModel)]="newPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="newPassword" (input)="CheckMatchPassword(1)" class="form-control required" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>
          {{'MasterPageComponent.Labels.ConfirmPassword' | translate }}
          <span *ngIf="checkMatchPassword" class="password-warrning">*</span>
        </label>
        <!--<p-password [(ngModel)]="confirmPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="confirmPassword" (input)="CheckMatchPassword(2)" class="form-control required" />
      </div>

      <div class="form-group form-group-sm col-md-12">
        <div class="kt-form__actions kt-form__actions--right">
          <button class="btn btn-sm btn-brand" [disabled]="!IsValidChangePassword()" (click)="ChangePassword()">{{'MasterPageComponent.Labels.Update' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
